import { useQuery } from "react-query";
import * as ajaxEndpoints from "../api/ajax-endpoints";
import { getData } from "../newApis/dotNetApiMethods";
import { IResponse } from "../interfaces/response";

export type InvestmentInterestType = {
  name: string;
  description1: string;
  description2: string;
  liquidationType: string;
  id: number;
};

export const getInterestPaymentTypes = async () => {
  const { data } = await getData(
    `${ajaxEndpoints.INVESTMENT_INTEREST_PAYMENT_TYPE}`
  );
  return data;
};

export default function useInvestmentInterestTypes() {
  return useQuery<IResponse<InvestmentInterestType[]>, any>(
    ["investmentInterestTypes"],
    getInterestPaymentTypes,
    {
      refetchOnWindowFocus: false,
    }
  );
}
